import { inject, Injectable } from '@angular/core';
import { TabConfig } from './models/tab-config.model';
import { PanelConfigService } from './panel-config.service';
import { SplitterConfig } from './models/splitter-config.model';

@Injectable({
  providedIn: 'root',
})
export class PanelManagerService {
  private components: TabConfig[] = [];
  private splittersState: SplitterConfig[] = [];

  private panelConfigService = inject(PanelConfigService);

  public constructor() {
    this.components = this.panelConfigService.loadOpenTabs();
    this.splittersState = this.panelConfigService.loadSplitterState();
  }

  public getComponents(): TabConfig[] {
    return this.components;
  }

  public openComponent(config: TabConfig): void {
    const existing = this.components.find(c => c.idAction === config.idAction);
    if (!existing) {
      this.components.push(config);
    } else {
      existing.isActive = true;
    }
    this.saveComponents();
  }

  public closeComponent(idAction: string): void {
    const component = this.components.find(c => c.idAction === idAction);
    if (component) {
      component.isActive = false;
    }
    this.saveComponents();
  }

  private saveComponents(): void {
    this.panelConfigService.saveOpenTabs(this.components);
  }

  public saveCurrentTab(tabPosition: number): void {
    this.panelConfigService.saveCurrentTab(this.getTabConfig(tabPosition));
  }

  public onLoadGetCurrentTab(): number {
    const currentTab = this.panelConfigService.getCurrentTab();
    return currentTab ? currentTab.indexTabRibbon : null;
  }

  private getTabConfig(tabPosition: number): TabConfig {
    const tabToSave = this.components.find(tab => tab.indexTabRibbon === tabPosition)
    return tabToSave;
  }

  public saveSplitterState(splitterConfig: SplitterConfig): void {
    const indexState = this.splittersState.findIndex(splitState => splitState.splitterName === splitterConfig.splitterName);
    if(indexState === -1) {
      this.splittersState.push(splitterConfig);
    }else {
      this.splittersState[indexState] = splitterConfig;
    }
    this.panelConfigService.saveSplitterStates(this.splittersState);
  }

  public getSplittersState(): SplitterConfig[] {
    const splittersState = this.panelConfigService.getSplitterState();
    return splittersState;
  }
}
